<template>
  <div class="loading-wrapper">
    <div
      class="loading"
      :class="{ 'black-and-white': blackAndWhite }"
      :style="{
        fontSize: constrainedSize + 'px',
        opacity: showAnimation ? 1 : 0,
      }"
    >
      <svg height="14" width="45" viewBox="0 0 45 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.349 13.728c5.586.783 25.048-2.26 37.71 0 4.508.804 4.508-11.26 0-12.065-11.542-2.06-26.841-2.37-37.71 0-3.69.804-2.87 11.662 0 12.065z" />
      </svg>
      <svg height="15" width="42" viewBox="0 0 42 15" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.99 1.764C8.07.445 25.961.54 38.415 1.764c3.083.304 5.223 12.656 0 12.248-13.572-1.06-24.299 1.913-35.425 0-4.75-.816-3.143-11.431 0-12.248z" />
      </svg>
      <svg height="15" width="43" viewBox="0 0 43 15" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.114.641c-14.88 0-24.933 1.644-36.667 0-4.31-.604-2.342 11.92 0 12.33 11.204 1.968 32.847 2.056 36.667 0 2.152-1.157 4.022-12.33 0-12.33z" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: 48,
      type: Number,
    },
    blackAndWhite: {
      default: true,
      type: Boolean,
    }
  },
  data() {
    return {
      showAnimation: false,
    }
  },
  computed: {
    constrainedSize() {
      return Math.min(Math.round(window.innerWidth / 7), this.size)
    },
  },
  created() {
    setTimeout(() => {
      this.showAnimation = true
    }, 750)
  }
}
</script>

<style lang="scss" scoped>
.loading-wrapper {
  width: 100%;
  height: 100vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  display: flex;
  flex-direction: column;
  padding: 0 1.75em 0 1em;
  transition: opacity 1.25s;

  svg {
    margin-bottom: 0.25em;
    width: 100%;
    height: 1em;
    animation: 1s bounce infinite alternate both;
    path { transition: fill .5s ease; }
    &:nth-child(1) {
      path { fill: #ff5979; }
      padding-left: 0.75em;
    }
    &:nth-child(2) {
      path { fill: #4b61ee; }
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      path { fill: #09d3e0; }
      margin-bottom: 0;
      padding-left: 0.5em;
      animation-delay: 0.4s;
    }
  }
  &.black-and-white {
    svg {
      &:nth-child(1) {
        path { fill: #e3e3e3; }
      }
      &:nth-child(2) {
        path { fill: #dadada; }
      }
      &:nth-child(3) {
        path { fill: #e6e6e6; }
      }
    }
  }
}

@keyframes bounce {
  from {
    transform: translateX(-1em);
  }
  to {
    transform: translateX(1em);
  }
}
</style>